<template>
  <div class="pic-container">
    <div class="gobtn" align="center">
      <el-button type="success" @click="showDialog">点击到这里去</el-button>
    </div>
    <div v-for="(item, index) in imgList" :key="index" class="img-container">
      <!-- <img
        :src="'http://193.112.181.218:8090/' + item.imageUrl"
        class="col-img"
      /> -->
      <img
        :src="'/file/' + item.imageUrl"
        class="col-img"
      />
      
    </div>
    <el-dialog
      :visible.sync="showChoice"
      class="choiceContainer"
      title="请选择导航方式"
    >
      <ul class="choice">
        <li @click="handleBack">APP画线</li>
        <li id="gaode" @click="toGaode">高德地图</li>
        <li id="baidu" @click="toBaidu">百度地图</li>
      </ul>
      <div class="cancel">
        <span @click="showChoice = false">取消</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { searchMarkPic, getCoord } from "../api/api";
import { Toast} from "vant";
import CallApp from "callapp-lib";
export default {
  name: "PicDetail",
  data() {
    return {
      showChoice: false,
      imgList: []
    };
  },
  methods: {
    handleBack() {
      this.$router.push({
        name: "MapBox",
        query: {
          position: 1
        }
      });
      this.$store.commit("tellMapFrom", true);
    },
    showDialog() {
      this.showChoice = true;
    },
    toGaode() {
      let url = `amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat=${this.$route.query.coord[0]}&dlon=${this.$route.query.coord[1]}&dname=&dev=1&t=0`;
      window.location.href = url;
      setTimeout(() => {
        Toast.fail("手机未安装高德地图"); 
      }, 500);
    },
    toBaidu() {
      let url = `bdapp://map/direction?origin=name:我的位置|latlng:${this.$route.query.localCoord[0]},${this.$route.query.localCoord[1]}&destination=${this.$route.query.coord[0]},${this.$route.query.coord[1]}&mode=driving&coord_type=wgs84&region=广州&output=html`;
      //let url1 = `http://api.map.baidu.com/geocoder?location=${this.query.localCoord[0]},${this.query.localCoord[1]}&output=json&key=Ya2nSaqjT3vNrIgba1v4nfWzSxGdtgZD&coordtype=wgs84||`
      window.location.href = url;
      setTimeout(() => {
        Toast.fail("手机未安装百度地图"); 
      }, 500);
    }
  },
  computed: {
    markerId() {
      return this.$route.query.markerId;
    }
  },
  async mounted() {
    this.$store.commit("tellMapFrom", false);
    let param = {
      markerId: this.markerId
    };
    searchMarkPic(param).then(res => {
      if (res.data.code === 600) {
        this.imgList = res.data.data.map(item => item);
      }
    });
  }
};
</script>

<style lang="less">
.pic-container {
  padding: 10px;
  margin-top: 130px;
  min-height: 100%;
}
.img-container {
  width: 90%;
  margin: 5px auto;
}
.img-container img {
  height: 100%;
  width: 100%;
  display: block;
}
.choice {
  width: 100%;
  li {
    text-align: center;
    font-size: 30px;
    line-height: 80px;
    display: block;
    border-top: 1px solid #eeeeee;
  }
  li:first {
    border-top: none;
  }
}
.choiceContainer .el-dialog {
  position: absolute;
  bottom: -5vh;
  width: 100%;
}
.el-dialog__header {
  text-align: center;
}
.el-dialog__body {
  padding-left: 0;
  padding-right: 0;
}
.cancel {
  border-top: 6px solid #eeeeee;
  font-size: 30px;
  line-height: 60px;
  text-align: center;
  padding-top: 10px;
}
.el-dialog__title {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/picdetail.vue